module.exports = __webpack_public_path__ + "static/media/email.24e31b6d.svg";